import { Show } from "solid-js";
import { useI18n } from "@/api/i18n";
import postHogClient from "@/api/posthog";
import {
  COOKIE_POLICY_URL,
  PRIVACY_URL,
  TERMS_URL,
} from "../constants/consent";
import {
  getDebugOverride,
  isTrackingAvailable,
  openPreferences,
} from "../store/consent-store";

const LINK_CLASS =
  "text-sm text-gray-600 hover:text-gray-900 transition-colors";

/**
 * Global in-app footer and the persistent re-entry point for consent (SPEC AC 8).
 * Reachable by anonymous and authenticated users on every surface (mounted once at
 * the router root — see the T5 layout audit). Legal links always show; the
 * "Preferenze cookie" entry is hidden where nothing can be tracked (env off + no
 * QA override) so it is never a dead-end (A4).
 */
export function GlobalFooter() {
  const { t } = useI18n();

  // env and the QA override are fixed for the session.
  const showPreferences = isTrackingAvailable(
    postHogClient.getIsEnabled(),
    getDebugOverride(),
  );

  return (
    <footer class="w-full border-t border-gray-200 bg-white">
      <div class="mx-auto max-w-7xl px-4 py-4 lg:px-8">
        <div class="flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-6">
          <a
            href={TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            class={LINK_CLASS}
          >
            {t("cookie_consent.footer.terms")}
          </a>
          <a
            href={PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            class={LINK_CLASS}
          >
            {t("cookie_consent.footer.privacy")}
          </a>
          <a
            href={PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            class={LINK_CLASS}
          >
            {t("cookie_consent.footer.accessibility")}
          </a>
          <a
            href={COOKIE_POLICY_URL}
            target="_blank"
            rel="noopener"
            class={LINK_CLASS}
          >
            {t("cookie_consent.footer.cookie_policy")}
          </a>
          <Show when={showPreferences}>
            <button
              type="button"
              onClick={openPreferences}
              class={`${LINK_CLASS} cursor-pointer underline underline-offset-4`}
            >
              {t("cookie_consent.footer.preferences")}
            </button>
          </Show>
        </div>
      </div>
    </footer>
  );
}
